import React from 'react'
import EventHeader from './EventHeader'
import EventContent from './EventContent'
import SocialInteractions from './SocialInteractions'

const EventFeedCard = ({ event, currentUserId, onEventClick }) => {
  return (
    <div className="bg-white/10 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/20 overflow-hidden hover:shadow-3xl transition-all duration-300">
      <EventHeader event={event} />
      <EventContent event={event} onClick={() => onEventClick(event._id)} />
      <SocialInteractions event={event} currentUserId={currentUserId} />
    </div>
  )
}

export default EventFeedCard